/* eslint-disable arrow-body-style */
export const wait = async (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
